"use client"

import React, {useEffect, useRef, useState} from "react";
import styled, {css} from "styled-components";

const StyledMarquee = styled.div`
    white-space: nowrap;
    //position: relative;
    //z-index: 1;
    //width: 100%;
    width: calc(100% + 10px);
    margin-right: -5px;
    margin-left: -5px;
    padding-right: 5px;
    padding-left: 5px;
    overflow: hidden;

    ${(props) => !props.$onHover && Math.abs(props.$width) > 0 && css`
        mask-image: linear-gradient(to right, transparent 0, red 5px, #000 calc(100% - 5px), transparent 100%);
    `
    };

    ${(props) => props.$onHover && Math.abs(props.$width) > 0 && css`
        mask-image: linear-gradient(to right, transparent 0, red 5px, red calc(100% - 5px), transparent 100%);
    `};


    ${(props) => !props.$onHover && Math.abs(props.$width) > 0 && css`

        & .content {
            animation: bounce${(props) => props.$width} ${(props) => Math.sqrt(Math.abs(props.$width)) + 2}s linear infinite;
        }
    `};

    ${(props) => props.$onHover && Math.abs(props.$width) > 0 && css`
        &:hover {

            & .content {
                animation: bounce${(props) => props.$width} ${(props) => Math.sqrt(Math.abs(props.$width)) + 2}s linear infinite;
            }
        }
    `};


    @keyframes bounce${(props) => props.$width} {
        15%, 85% {
            transform: translateX(0);
        }

        35%, 65% {
            transform: translateX(${(props) => props.$width + "px"});
        }
    }
`

function getEffectiveBackgroundColor(element) {
    let currentElement = element;
    while (currentElement) {
        const computedStyle = window.getComputedStyle(currentElement);
        const bgColor = computedStyle.backgroundColor;

        if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
            return bgColor;
        }

        currentElement = currentElement.parentElement;
    }

    return 'transparent';
}

const Marquee = React.forwardRef(({children, onHover = false, selfClass, className, ...props}, ref) => {
    ref = useRef();
    const parentRef = useRef();

    // const [bgColor, setBGColor] = useState("transparent");
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (!ref?.current) return;

        let width2 = ref?.current?.scrollWidth - parentRef?.current?.clientWidth + 10;
        if (width2 < 0) width2 = 0;
        if (window.getComputedStyle(ref.current).textAlign == "left" || window.getComputedStyle(ref.current).direction == "ltr")
            width2 *= -1;

        setWidth(width2);
        // setBGColor(getEffectiveBackgroundColor(ref.current));
    }, [ref?.current?.scrollWidth, ref?.current?.offsetWidth]);

    return <StyledMarquee $width={width} $onHover={onHover} className={selfClass} ref={parentRef}>
        <div className={`content text-nowrap ${className}`} {...props} ref={ref}>
            {children}
        </div>
    </StyledMarquee>


    /* useEffect(() => {
         const marquee = ref?.current;
         if (!marquee) return;

         const marqueeWidth = marquee.offsetWidth;
         const textWidth = marquee.innerWidth || marqueeWidth;
         console.log(marquee, marqueeWidth, textWidth);

         const animationDuration = (textWidth / marqueeWidth) * 1; // 10s is the duration in the CSS animation

         marquee.style.animationDuration = `${animationDuration}s`;
     }, [ref]);

     return <StyledMarquee {...props} ref={ref}>{children}</StyledMarquee>;*/
});

export default Marquee;
